import { BuildingId, Device, DeviceFile, DeviceId } from 'shared/models';

export const Actions = {
    CREATE_DEVICES_SUCCESS: 'CREATE_DEVICES_SUCCESS',

    UPDATE_DEVICE_SUCCESS: 'UPDATE_DEVICE_SUCCESS',

    GROUP_DEVICES_REQUEST: 'GROUP_DEVICES_REQUEST',
    GROUP_DEVICES_SUCCESS: 'GROUP_DEVICES_SUCCESS',
    GROUP_DEVICES_FAILURE: 'GROUP_DEVICES_FAILURE',

    DELETE_DEVICE_SUCCESS: 'DELETE_DEVICE_SUCCESS',

    DISABLE_DEVICE_REQUEST: 'DISABLE_DEVICE_REQUEST',
    DISABLE_DEVICE_SUCCESS: 'DISABLE_DEVICE_SUCCESS',
    DISABLE_DEVICE_FAILURE: 'DISABLE_DEVICE_FAILURE',

    GET_DEVICE_DETAILS_REQUEST: 'GET_DEVICE_DETAILS_REQUEST',
    GET_DEVICE_DETAILS_SUCCESS: 'GET_DEVICE_DETAILS_SUCCESS',
    GET_DEVICE_DETAILS_FAILURE: 'GET_DEVICE_DETAILS_FAILURE',

    DELETE_DEVICE_FILE_REQUEST: 'DELETE_DEVICE_FILE_REQUEST',
    DELETE_DEVICE_FILE_SUCCESS: 'DELETE_DEVICE_FILE_SUCCESS',
    DELETE_DEVICE_FILE_FAILURE: 'DELETE_DEVICE_FILE_FAILURE',

    UPDATE_DEVICE_SCRIPT: 'UPDATE_DEVICE_SCRIPT',

    PUBLISH_DEVICE_SCRIPT_REQUEST: 'PUBLISH_DEVICE_SCRIPT_REQUEST',
    PUBLISH_DEVICE_SCRIPT_SUCCESS: 'PUBLISH_DEVICE_SCRIPT_SUCCESS',
    PUBLISH_DEVICE_SCRIPT_FAILURE: 'PUBLISH_DEVICE_SCRIPT_FAILURE',

    CANCEL_DEVICE_SCRIPT_REQUEST: 'CANCEL_DEVICE_SCRIPT_REQUEST',
    CANCEL_DEVICE_SCRIPT_SUCCESS: 'CANCEL_DEVICE_SCRIPT_SUCCESS',
    CANCEL_DEVICE_SCRIPT_FAILURE: 'CANCEL_DEVICE_SCRIPT_FAILURE',
};

export type DeviceStatus = any[];

export type DeviceDetails = {
    files: DeviceFile[];
    script?: string;
};

export const createDevicesSuccess = (devices: Device[], meta: { buildingId: BuildingId }) => ({
    type: Actions.CREATE_DEVICES_SUCCESS,
    payload: devices,
    meta,
});

export const updateDeviceSuccess = (device: Device) => ({
    type: Actions.UPDATE_DEVICE_SUCCESS,
    payload: device,
});

export const groupDevicesRequest = ({ buildingId, deviceIds, groupName }: { buildingId: string; deviceIds: string[]; groupName: string }) => ({
    type: Actions.GROUP_DEVICES_REQUEST,
    payload: { buildingId, deviceIds, groupName }, // pass groupName = 'none' to ungroup
});
export const groupDevicesSuccess = ({ buildingId, devices }: { buildingId: string; devices: Device[] }) => ({
    type: Actions.GROUP_DEVICES_SUCCESS,
    payload: devices,
    meta: { buildingId },
});
export const groupDevicesFailure = (err: Error, buildingId: string) => ({
    type: Actions.GROUP_DEVICES_FAILURE,
    payload: err,
    error: true,
    meta: { buildingId },
});

export const deleteDeviceSuccess = (meta: { deviceId: DeviceId; buildingId: BuildingId }) => ({
    type: Actions.DELETE_DEVICE_SUCCESS,
    meta,
});

export const disableDeviceRequest = (buildingId: string, deviceId: string) => ({
    type: Actions.DISABLE_DEVICE_REQUEST,
    payload: { buildingId, deviceId },
});
export const disableDeviceSuccess = (buildingId: string, deviceId: string) => ({
    type: Actions.DISABLE_DEVICE_SUCCESS,
    meta: { buildingId, deviceId },
});
export const disableDeviceFailure = (buildingId: string, deviceId: string, err: Error) => ({
    type: Actions.DISABLE_DEVICE_FAILURE,
    payload: err,
    error: true,
    meta: { buildingId, deviceId },
});

export const getDeviceDetailsRequest = (buildingId: string, deviceId: string) => ({
    type: Actions.GET_DEVICE_DETAILS_REQUEST,
    payload: { buildingId, deviceId },
});
export const getDeviceDetailsSuccess = (buildingId: string, deviceId: string, details: DeviceDetails) => ({
    type: Actions.GET_DEVICE_DETAILS_SUCCESS,
    payload: details,
    meta: { buildingId, deviceId },
});
export const getDeviceDetailsFailure = (buildingId: string, deviceId: string, err: Error) => ({
    type: Actions.GET_DEVICE_DETAILS_FAILURE,
    payload: err,
    error: true,
    meta: { buildingId, deviceId },
});

export const deleteDeviceFileRequest = (buildingId: string, deviceId: string, fileId: string) => ({
    type: Actions.DELETE_DEVICE_FILE_REQUEST,
    payload: { buildingId, deviceId, fileId },
});
export const deleteDeviceFileSuccess = (buildingId: string, deviceId: string, fileId: string) => ({
    type: Actions.DELETE_DEVICE_FILE_SUCCESS,
    meta: { buildingId, deviceId, fileId },
});
export const deleteDeviceFileFailure = (buildingId: string, deviceId: string, fileId: string, err: Error) => ({
    type: Actions.DELETE_DEVICE_FILE_FAILURE,
    payload: err,
    error: true,
    meta: { buildingId, deviceId, fileId },
});

export const updateDeviceScript = (buildingId: string, deviceId: string, script: string) => ({
    type: Actions.UPDATE_DEVICE_SCRIPT,
    payload: { buildingId, deviceId, script },
});

export const publishDeviceScriptRequest = (buildingId: string, deviceId: string, script: string | null, scope: 'device' | 'group' | 'building') => ({
    type: Actions.PUBLISH_DEVICE_SCRIPT_REQUEST,
    payload: { buildingId, deviceId, script, scope },
});
export const publishDeviceScriptSuccess = (buildingId: string, deviceId: string, script: string) => ({
    type: Actions.PUBLISH_DEVICE_SCRIPT_SUCCESS,
    meta: { buildingId, deviceId, script },
});
export const publishDeviceScriptFailure = (buildingId: string, deviceId: string, err: Error) => ({
    type: Actions.PUBLISH_DEVICE_SCRIPT_FAILURE,
    payload: err,
    error: true,
    meta: { buildingId, deviceId },
});

export const cancelDeviceScriptRequest = (buildingId: string, deviceId: string) => ({
    type: Actions.CANCEL_DEVICE_SCRIPT_REQUEST,
    payload: { buildingId, deviceId },
});
export const cancelDeviceScriptSuccess = (buildingId: string, deviceId: string) => ({
    type: Actions.CANCEL_DEVICE_SCRIPT_SUCCESS,
    meta: { buildingId, deviceId },
});
export const cancelDeviceScriptFailure = (buildingId: string, deviceId: string, err: Error) => ({
    type: Actions.CANCEL_DEVICE_SCRIPT_FAILURE,
    payload: err,
    error: true,
    meta: { buildingId, deviceId },
});
